export default __webpack_public_path__ + "static/e4c2f42e-6457e224d4d2bc40654926e246802d52.jpeg";